module.exports = __webpack_public_path__ + "static/media/8.f2f324c9.jpg";